@if (event.isRegistrationOpen() && !event.isEventInThePast()) {
@if (event.freeEvent) {
<app-free-registration></app-free-registration>
} @else {
<app-registration></app-registration>
}
} @else {
<app-registration-closed></app-registration-closed>
}